<!-- 데스크톱 레이아웃 -->
<main class="hidden lg:flex flex-col w-full pt-30 pb-15">
  <div class="flex flex-col gap-6 mx-auto max-w-7xl w-full px-6">
    <div class="max-w-120">
      <app-segment [options]="options" [(value)]="segment" />
    </div>
    <div class="w-full text-left">
      <ng-container *ngTemplateOutlet="termContentTemplate"></ng-container>
    </div>
  </div>
</main>

<!-- 모바일 레이아웃 -->
<app-page-modal-container class="lg:hidden">
  <main class="pb-6">
    <div class="flex flex-col gap-6 pt-4 px-4">
      <app-segment [options]="options" [(value)]="segment" />
      <ng-container *ngTemplateOutlet="termContentTemplate"></ng-container>
    </div>
  </main>
</app-page-modal-container>

<!-- 약관 컨텐츠 템플릿 -->
<ng-template #termContentTemplate>
  @if ($term.value(); as term) {
  <div class="editor-content prose max-w-none" [innerHTML]="term | safeHtml"></div>
  } @else {
  <app-not-found [isLoading]="$term.isLoading()">
    <p class="text-gray-500">약관 내용이 없습니다.</p>
  </app-not-found>
  }
</ng-template>
